import { generateCssVars } from '@gameday/react-components/utils/theme'
import { createGlobalStyle } from 'styled-components'

const cssVars = generateCssVars()

const GlobalStyle = createGlobalStyle`
  &:root {
    ${cssVars[0]};
    --white: #ffffff;
    --dark-text: #4a4a4a;
    --light-text: var(--white);
    --sub-text: #7d7d84;
    --date-text: #fcfcfc;
    --grey-section-bg: #fafafa;
    --border-color: #dedede;
    --icon-color: #c7c7c7;
    --map-box-bg: rgba(255,255,255,0.85);
  }

  html {
    box-sizing: border-box;
    font-family: 'Barlow', sans-serif;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
  }

  .wrapped:not(.label-inline) .field-label-col {
    margin-bottom: 4px;
  }
`
export default GlobalStyle
